export default __webpack_public_path__ + "static/media/cloth_3.645ff51c.jpg";